import { render } from "./RiderEmailVerification.vue?vue&type=template&id=18722e6b&scoped=true"
import script from "./RiderEmailVerification.vue?vue&type=script&lang=js"
export * from "./RiderEmailVerification.vue?vue&type=script&lang=js"

import "./RiderEmailVerification.vue?vue&type=style&index=0&id=18722e6b&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18722e6b"]])

export default __exports__